import { Button } from '#/shared/ui/button'
import { CopyIcon, DownloadIcon } from '#/shared/ui/icons'
import { toast } from '#/shared/ui/sonner'

function download(codes: string[], email: string) {
  const text = [
    `TheCargo admin console — recovery codes for ${email}`,
    'Each code signs you in once, after which you add a new passkey.',
    '',
    ...codes,
    '',
  ].join('\n')
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }))
  const link = document.createElement('a')
  link.href = url
  link.download = 'thecargo-admin-recovery-codes.txt'
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * Recovery codes, the one time they can be read.
 *
 * Only a hash of each is kept, so nothing can show them again. Copy and
 * Download both hand over the whole set at once, so it lands in one place — a
 * password manager or a file — rather than half of it.
 */
export function RecoveryCodeList({ codes, email }: { codes: string[]; email: string }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join('\n'))
    } catch {
      toast.error('Copying did not work — select the codes and copy them by hand.')
      return
    }
    toast.success('Recovery codes copied')
  }

  return (
    <div className="flex flex-col gap-3">
      <ol className="grid grid-cols-2 gap-x-6 gap-y-1.5 rounded-md border border-gray-200 bg-gray-50 px-4 py-3 font-mono text-sm text-gray-900">
        {codes.map((code) => (
          <li key={code}>{code}</li>
        ))}
      </ol>
      <div className="flex gap-2">
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="flex-1 text-gray-900"
          onClick={() => void copy()}
        >
          <CopyIcon className="size-4" />
          Copy
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="flex-1 text-gray-900"
          onClick={() => download(codes, email)}
        >
          <DownloadIcon className="size-4" />
          Download
        </Button>
      </div>
    </div>
  )
}
